import React, { PureComponent, ReactNode } from 'react';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
  WithStyles,
  createStyles,
  Typography,
  Grid,
  Button,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core';

import { MyPATExpansionPanel } from '../../../common';
import AddFeedback from '../../../content-request/components/AddFeedback';
import CustomInfoIcon from '../../../common/CustomInfoIcon';
import AddFeedbackPopup from './AddFeedbackPopup';
import { SECTIONS } from '../../helper/contentValidation';

const styles = (theme: Theme) => createStyles({
  blueColor: {
		color: '#1D7DEA'
	},
  feedbackContainer: {
		position: 'relative',
		'& .feedbackBlock': {
		  top: -16,
		  left: "100%",
		  position: "absolute",
		  marginLeft: 20,
		  zIndex: 2
		}
	  },
  mb2x: {
    marginBottom: theme.spacing.unit * 2,
  },
  cardHeading: {
    fontWeight: theme.typography.fontWeightRegular,
  },
  requiredHeading: {
    color: theme.palette.secondary.main,
  },
  borderBox: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing.unit * 2,
    '& button': {
      fontWeight: theme.typography.fontWeightRegular,
      marginRight: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
    },
  },
  difficultySkillsTable: {
    '& tbody': {
      '& tr': {
        '& td': {
          ...theme.typography.caption,
          position: 'relative',
          color: theme.palette.text.secondary,
          padding: theme.spacing.unit / 2,
          border: 0,
          textAlign: 'center',
          borderBottom: `1px dashed ${theme.palette.grey[400]}`,
          borderRight: `1px dashed ${theme.palette.grey[400]}`,
          // cursor: 'pointer',
          '&:first-child': {
            textAlign: 'right',
            border: 0,
            borderRight: `1px solid ${theme.palette.grey[500]}`,
          },
          '&:last-child': {
            borderRight: 0,
          },
        },
        '&:first-child': {
          '& td': {
            '&:first-child': {
              '&:after': {
                content: '">"',
                transform: 'rotate(-90deg)',
                position: 'absolute',
                display: 'inline-block',
                top: -10,
                right: -4,
                fontSize: theme.typography.fontSize,
                lineHeight: 0.95,
                color: theme.palette.grey[600],
              }
            },
          }
        },
        '&:last-child': {
          height: theme.spacing.unit * 3,
          '& td': {
            border: 0,
            borderTop: `1px solid ${theme.palette.grey[500]}`,
            '&:first-child': {
              border: 0,
            },
            '&:last-child': {
              '&:after': {
                content: '">"',
                position: 'absolute',
                display: 'inline-block',
                top: '-50%',
                right: -10,
                fontSize: theme.typography.fontSize,
                color: theme.palette.grey[600],
                lineHeight: 0.95,
                transform: 'translateY(50%)',
              }
            },
          }
        },
      },
    },
  },
  markingIcon: {
    display: 'inline-block',
    width: theme.spacing.unit * 3,
    height: theme.spacing.unit * 3,
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    boxShadow: theme.shadows[2],
  },
  feedbackHighlight:{
    cursor: 'pointer',
    '&:hover':{
      color: '#1d7dea',
    }
  },
  redColor: {
    color: '#F21D1D'
  },
  optionalText: {
    fontSize: '20px',
    color: '#999999',
  },
});

interface AddDifficultyAndSkillProps {
  classes: any;
  isRequired: boolean,
  customHeading: ReactNode,
  defaultExpanded: boolean,
  from: string,
  difficultyLevel: any,  
  difficultyType: any, 
  handleFormChange: Function,
  isDisable: boolean,
  tag: string,
  openFeedback: boolean,
  addFeedback: Function,
  replyFeedback: Function,
  closeFeedback: Function,
  resolveFeedback: Function,
  clickedfeedbackData: any,
  addNewFeedback: Function,
  questionIndex?: number,
  selectedIndex: number,
  questionId?: string,
  authorType?: string,
  isNotMandatory?: boolean,
  activeValidationFeedbackSection?: string;
  activeValidationFeedbackData?: number;
  handleAddCommentInFeedback?: Function;
  createNewValidationFeedback?: Function;
};


class AddDifficultyAndSkill extends PureComponent<AddDifficultyAndSkillProps> {
  constructor(props: AddDifficultyAndSkillProps) {
    super(props);
  }
  checkForFeedback() {
    let { clickedfeedbackData, questionId } = this.props;
    if(this.props.selectedIndex !== undefined) {
      return (( _.isEmpty(clickedfeedbackData) && this.props.openFeedback && this.props.tag === "difficulty" && this.props.selectedIndex === this.props.questionIndex) || (!_.isEmpty(clickedfeedbackData) && this.props.openFeedback && clickedfeedbackData.tag === "difficulty" && questionId === clickedfeedbackData.contentId))
    } else {
      return this.props.openFeedback && this.props.tag === "difficulty"

    }
  }
  handleDifficultyLevelChange = (skill: string) => {
    const difficultyType  = JSON.parse(JSON.stringify(this.props.difficultyType));
    let difficultyLevel  = JSON.parse(JSON.stringify(this.props.difficultyLevel));
    if (!difficultyLevel.includes(skill)) {
      difficultyLevel = [skill]
    } else {
      difficultyLevel = difficultyLevel.filter((ss: any )=> ss != skill);
    }
    this.props.handleFormChange(difficultyLevel, difficultyType, 'difficultyLevel');
  };

  handleDifficultyTypeChange = (d: string) => {
    const difficultyLevel  = JSON.parse(JSON.stringify(this.props.difficultyLevel));
    let difficultyType  = JSON.parse(JSON.stringify(this.props.difficultyType));
    if (!difficultyType.includes(d)) {
      difficultyType.push(d);
    } else {
      difficultyType = difficultyType.filter((dd: any) => dd != d);
    }
    this.props.handleFormChange(difficultyLevel, difficultyType, 'difficultyType');
  };

  handleCellClick = (level: string, type: string) => {
    // Working wrong so leveling it for now as functionality also not clear 
    // let difficultyLevel  = JSON.parse(JSON.stringify(this.props.difficultyLevel));
    // let difficultyType  = JSON.parse(JSON.stringify(this.props.difficultyType));
    // if (difficultyLevel.includes(level) && difficultyType.includes(type)) {
    //   difficultyType = difficultyType.filter((dd: any) => dd != type);
    //   difficultyLevel = difficultyLevel.filter((ss: any )=> ss != level);
    // } else {
    //   if (!difficultyLevel.includes(level)){
    //     difficultyLevel.push(level);
    //   }
    //   if (!difficultyType.includes(type)){
    //     difficultyType.push(type);
    //   }
    // }
    // this.props.handleFormChange(difficultyLevel, difficultyType);
  };

  render() {
    const { classes, isRequired, customHeading, defaultExpanded, difficultyLevel, difficultyType, questionIndex, isNotMandatory, activeValidationFeedbackSection, activeValidationFeedbackData, handleAddCommentInFeedback, createNewValidationFeedback } = this.props;
    const difficultySkillLabel = `${difficultyLevel}-${difficultyType}`;
    const MarkingIcon = () => <span className={classes.markingIcon}></span>;
    return (
      <MyPATExpansionPanel
        hasExpandIcon
        defaultExpanded={defaultExpanded}

        variant="white"
        customCollapseTitle={
          !_.isEmpty(customHeading) ? customHeading : (
            <>
             
            <Typography variant="h6" className={classes.cardHeading} onClick={(event) => {
              event.stopPropagation();
              this.props.addFeedback('difficulty', questionIndex)}}>
            <span 
            id={this.checkForFeedback() ? 'feedbackScroll' : 'addDifficultyAndSkills'}
            className={`${classes.feedbackContainer} ${this.checkForFeedback() ? classes.blueColor : ''} ${this.props.openFeedback ? classes.feedbackHighlight : ''}`}>Add Difficulty And Skill
              {!isNotMandatory ?
               <span className={classes.redColor}>*</span> 
                : <span className={classes.optionalText}> (Optional)</span>
              }
              {this.checkForFeedback() && (
                <Grid className="feedbackBlock">
                   <AddFeedback 
                   author={this.props.authorType}
                   replyFeedback={this.props.replyFeedback} closeFeedback={this.props.closeFeedback} resolveFeedback={this.props.resolveFeedback} clickedfeedbackData={this.props.clickedfeedbackData} addNewFeedback={this.props.addNewFeedback} />
              </Grid>)}
                {
                  activeValidationFeedbackSection === SECTIONS.DIFFICULTY && (
                    <AddFeedbackPopup isAuthor={true} allowFeedbacks={true} handleAdd={handleAddCommentInFeedback} handleCancel={()=>createNewValidationFeedback && createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                  )
                }
              </span>
              <CustomInfoIcon
                infoDialogContentType="Goal Management"
                isInfoIcon={true}
                isRightArrow={false}
                isCenterArrow={true}
                knowMoreAbout={false}
                dialogTitle="Add Difficulty & Skill"
                imageURL="/assets/svg/infoIcon/skillAndDifficulty.svg"
                dialogPara="Select the Difficulty level (Easy, Medium or Difficult) and Skill type (Conceptual, Analytical, Intuitive) of the Question"
                details="Click to know more"
                toolTipDirection="top" />
            </Typography>
            </>
          )
        }
        isDisable={this.props.isDisable}
      >
        <div className={classes.borderBox}>
          <Grid container spacing={16}>
            <Grid item sm={6}>
              <Typography variant="caption" gutterBottom>Difficulty Level</Typography>
              <Button
                variant="outlined"
                color={difficultyLevel.includes('easy') ? 'primary' : 'default'}
                onClick={this.handleDifficultyLevelChange.bind(this, 'easy')}
              >
                Easy
                </Button>
              <Button
                variant="outlined"
                color={difficultyLevel.includes('medium') ? 'primary' : 'default'}
                onClick={this.handleDifficultyLevelChange.bind(this, 'medium')}
              >
                Medium
                </Button>
              <Button
                variant="outlined"
                color={difficultyLevel.includes('difficult') ? 'primary' : 'default'}
                onClick={this.handleDifficultyLevelChange.bind(this, 'difficult')}
              >
                Difficult
                </Button>

              <Typography variant="caption" gutterBottom style={{ marginTop: 8 }}>Skill Level</Typography>
              <Button
                variant="outlined"
                color={_.includes(difficultyType, 'conceptual') ? 'primary' : 'default'}
                onClick={this.handleDifficultyTypeChange.bind(this, 'conceptual')}
              >
                Conceptual
                </Button>
              <Button
                variant="outlined"
                color={_.includes(difficultyType, 'analytical') ? 'primary' : 'default'}
                onClick={this.handleDifficultyTypeChange.bind(this, 'analytical')}
              >
                Analytical
                </Button>
              <Button
                variant="outlined"
                color={_.includes(difficultyType, 'intuitive') ? 'primary' : 'default'}
                onClick={this.handleDifficultyTypeChange.bind(this, 'intuitive')}
              >
                Intuitive
                </Button>
            </Grid>

            <Grid item sm={6}>
              <Table className={classes.difficultySkillsTable}>
                <TableBody>
                  <TableRow>
                    <TableCell>Difficult</TableCell>
                    <TableCell onClick={() => { this.handleCellClick('difficult', 'conceptual') }}>
                      {_.includes(difficultyLevel, 'difficult') && _.includes(difficultyType, 'conceptual') && <MarkingIcon />}
                    </TableCell>
                    <TableCell onClick={() => { this.handleCellClick('difficult', 'analytical') }}>
                      {_.includes(difficultyLevel, 'difficult') && _.includes(difficultyType, 'analytical') && <MarkingIcon />}
                    </TableCell>
                    <TableCell onClick={() => { this.handleCellClick('difficult', 'intuitive') }}>
                      {_.includes(difficultyLevel, 'difficult') && _.includes(difficultyType, 'intuitive') && <MarkingIcon />}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Medium</TableCell>
                    <TableCell onClick={() => { this.handleCellClick('medium', 'conceptual') }}>
                      {_.includes(difficultyLevel, 'medium') && _.includes(difficultyType, 'conceptual') && <MarkingIcon />}
                    </TableCell>
                    <TableCell onClick={() => { this.handleCellClick('medium', 'analytical') }}>
                      {_.includes(difficultyLevel, 'medium') && _.includes(difficultyType, 'analytical') && <MarkingIcon />}
                    </TableCell>
                    <TableCell onClick={() => { this.handleCellClick('medium', 'intuitive') }}>
                      {_.includes(difficultyLevel, 'medium') && _.includes(difficultyType, 'intuitive') && <MarkingIcon />}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Easy</TableCell>
                    <TableCell onClick={() => { this.handleCellClick('easy', 'conceptual') }}>
                      {_.includes(difficultyLevel, 'easy') && _.includes(difficultyType, 'conceptual') && <MarkingIcon />}
                    </TableCell>
                    <TableCell onClick={() => { this.handleCellClick('easy', 'analytical') }}>
                      {_.includes(difficultyLevel, 'easy') && _.includes(difficultyType, 'analytical') && <MarkingIcon />}
                    </TableCell>
                    <TableCell onClick={() => { this.handleCellClick('easy', 'intuitive') }}>
                      {_.includes(difficultyLevel, 'easy') && _.includes(difficultyType, 'intuitive') && <MarkingIcon />}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>&nbsp;</TableCell>
                    <TableCell>Conceptual</TableCell>
                    <TableCell>Analytical</TableCell>
                    <TableCell>Intuitive</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
          </Grid>
        </div>
      </MyPATExpansionPanel>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(AddDifficultyAndSkill);